// @ts-nocheck
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import Web3WalletAuthPanel from '../../containers/AuthenticationPage/Web3WalletAuthPanel/Web3WalletAuthPanel';
import { fetchWeb3AuthSession } from '../../util/web3Auth';
import { PrimaryButton } from '../Button/Button';

import css from './WalletLinkCallout.module.css';

export interface WalletLinkCalloutProps {
  isAuthenticated?: boolean;
  className?: string;
}

const WalletLinkCallout: React.FC<WalletLinkCalloutProps> = ({
  isAuthenticated = false,
  className = null,
}) => {
  const [needsWallet, setNeedsWallet] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setNeedsWallet(false);
      setChecked(true);
      return undefined;
    }

    let cancelled = false;

    fetchWeb3AuthSession()
      .then(session => {
        if (cancelled) {
          return;
        }
        const linked = Boolean(session?.authenticated && session?.identity?.walletAddress);
        setNeedsWallet(!linked);
        setChecked(true);
      })
      .catch(() => {
        if (!cancelled) {
          setNeedsWallet(true);
          setChecked(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  if (!isAuthenticated || !checked || !needsWallet) {
    return null;
  }

  return (
    <section
      className={classNames(css.root, className)}
      data-testid="wallet-link-callout"
      aria-labelledby="wallet-link-callout-title"
    >
      <div className={css.header}>
        <p className={css.eyebrow}>Web3 onboarding</p>
        <h2 id="wallet-link-callout-title" className={css.title}>
          Link your Web3 Wallet to Start Transacting
        </h2>
        <p className={css.body}>
          Connect MetaMask or Rabby, then sign a one-time message to link your Sharetribe account to
          your public wallet address for escrow and payouts.
        </p>
      </div>

      {!showPanel ? (
        <div className={css.actions}>
          <PrimaryButton type="button" onClick={() => setShowPanel(true)}>
            Connect wallet &amp; sign
          </PrimaryButton>
        </div>
      ) : (
        <div className={css.panelWrap}>
          <Web3WalletAuthPanel onAuthenticated={() => setNeedsWallet(false)} />
        </div>
      )}
    </section>
  );
};

export default WalletLinkCallout;
